import { Injector } from '@angular/core';
import { draggableNodeStopEvent } from '@examdojo/core/tiptap';
import { Node } from '@tiptap/core';
import { AngularNodeViewRenderer } from 'ngx-tiptap';
import { parseJsonAttr } from '../parse-json-attr.util';
import { DataDisplayNodeComponent } from './data-display.component';
import { DATA_DISPLAY_NODE_NAME, DEFAULT_DATA_DISPLAY_PROPS } from './data-display.model';

export const DataDisplayExtension = (injector: Injector) => {
  return Node.create({
    name: DATA_DISPLAY_NODE_NAME,
    group: 'block',
    atom: true,
    selectable: true,
    draggable: true,

    addAttributes() {
      return {
        id: {
          default: '',
          renderHTML: (attributes) => ({ 'data-id': attributes['id'] }),
          parseHTML: (element) => element.getAttribute('data-id') ?? '',
        },
        data: {
          default: DEFAULT_DATA_DISPLAY_PROPS.data,
          renderHTML: (attributes) => ({
            'data-data': attributes['data'] ?? '',
          }),
          parseHTML: (element) => element.getAttribute('data-data') ?? '',
        },
        sorted: {
          default: false,
          renderHTML: (attributes) => (attributes['sorted'] === true ? { 'data-sorted': 'true' } : {}),
          parseHTML: (element) => element.getAttribute('data-sorted') === 'true',
        },
        custom_css: {
          default: '',
          renderHTML: (attributes) => (attributes['custom_css'] ? { 'data-custom-css': attributes['custom_css'] } : {}),
          parseHTML: (element) => element.getAttribute('data-custom-css') ?? '',
        },
        custom_style: {
          default: null,
          renderHTML: (attributes) =>
            attributes['custom_style'] ? { 'data-custom-style': JSON.stringify(attributes['custom_style']) } : {},
          parseHTML: (element) => parseJsonAttr(element, 'data-custom-style', null),
        },
      };
    },

    parseHTML() {
      return [{ tag: 'div.data-display-block' }];
    },

    renderHTML({ HTMLAttributes }) {
      return ['div', { class: 'data-display-block', ...HTMLAttributes }];
    },

    addNodeView() {
      return AngularNodeViewRenderer(DataDisplayNodeComponent, {
        injector,
        stopEvent: ({ event }) => {
          // When the user interacts with form elements (textarea, input, button) inside the
          // inline editor, stop the event from reaching ProseMirror so it doesn't steal focus.
          const target = event.target as HTMLElement;
          if (target?.closest?.('.data-display-edit, .data-display-edit-actions')) {
            return true;
          }
          return draggableNodeStopEvent({ event });
        },
      });
    },
  });
};
